import React from 'react';
import PropTypes from 'prop-types';

export const ArrowRightIcon = ({ width }) => {
  return (
    <svg
      width={width}
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      stroke="var(--titan-blue-3)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.94975 0.99996L12.8995 5.94971L7.94975 10.8995" strokeWidth="1.5" />
      <path d="M0 5.94971L13 5.94971" strokeWidth="1.5" />
    </svg>
  );
};

ArrowRightIcon.propTypes = {
  width: PropTypes.string, //24
};
ArrowRightIcon.defaultProps = {
  width: '14',
};
